<script>
export default {
  props: ['stableData'],
  data () {
    return {
      rangeoption1: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20,
          x2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ub',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Uc',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }
        ]
      },
      rangeoption2: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ia', 'Ib', 'Ic', 'In'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20,
          x2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ia',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ib',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Ic',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }, {
          name: 'In',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#00a1f5'
          },
          data: []
        }
        ]
      },
      chart: {},
      posSelectOptions: [{
        value: 1,
        label: '电压'
      }, {
        value: 2,
        label: '电流'
      }],
      posSelectValue: 1,
      // 频段下拉框
      freqSelectOptions: [{
        value: 1,
        label: '5~400 Hz'
      }, {
        value: 2,
        label: '405~800 Hz'
      }, {
        value: 3,
        label: '805~1200 Hz'
      }, {
        value: 4,
        label: '1205~1600 Hz'
      }, {
        value: 5,
        label: '1605~2000 Hz'
      }, {
        value: 6,
        label: '2005~2400 Hz'
      }, {
        value: 7,
        label: '2405~2800 Hz'
      }, {
        value: 8,
        label: '2805~3200 Hz'
      }],
      freqSelectValue: 1,
      showRms: {}
    }
  },
  watch: {
    posSelectValue () {
      this.Chart.clear()
      this.updateData()
    },
    freqSelectValue (val) {
      this.$store.commit('updateFreqSelectValue', val)
      // this.pollCommand()
      this.updateData()
    }
  },
  mounted () {
    this.freqSelectValue = this.$store.state.freqSelectValue
    this.Chart = this.$echarts.init(document.getElementById('rangeOptions'))
    // this.setValue(this.posSelectValue)

    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: '',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
    // this.pollCommand()
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    // this.pollStop()
  },
  methods: {
    // pollCommand () {
    //   if (this.$store.state.reqMode === 'udp' || this.$store.state.highSpdMode) {
    //     this.sendCommand(this.freqSelectValue)
    //     if (!this.commandInterval) {
    //       this.commandInterval = setInterval(() => {
    //         this.sendCommand(this.freqSelectValue)
    //       }, 600000)
    //     } else {
    //       this.pollStop()
    //       this.sendCommand(this.freqSelectValue)
    //       if (!this.commandInterval) {
    //         this.commandInterval = setInterval(() => {
    //           this.sendCommand(this.freqSelectValue)
    //         }, 600000)
    //       }
    //     }
    //   } else {
    //     this.pollStop()
    //   }
    // },
    // pollStop () {
    //   if (this.commandInterval) {
    //     clearInterval(this.commandInterval)
    //     this.commandInterval = null
    //   }
    // },
    // sendCommand (index) {
    //   const m = index << 4 & 0xf0 | 0x06
    //   this.$api.command({
    //     sn: this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
    //     lists: [[1, 6, m]]
    //   }).then(res => {
    //     if (res.data.code !== 0) {
    //       this.$message.error(res.data.msg)
    //     }
    //   })
    // },

    async updateData () {
      const params = {
        'collection': 'meter_inter_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['InterUa', 'InterUb', 'InterUc', 'InterIa', 'InterIb', 'InterIc', 'InterIn']
      }
      const {data: res} = await this.$api.queryLastData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      // console.log(res)
      this.setValue(res.data)
    },

    setValue (data) {
      var i = 0
      var interData = {
        a: [],
        b: [],
        c: [],
        n: []
      }
      if (this.posSelectValue === 1) {
        for (i = 0; i < 80; i++) {
          this.rangeoption1.xAxis[0].data[i] = (this.freqSelectValue - 1) * 400 + i * 5 + 5

          interData.a[i] = data.inter_ua[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
          interData.b[i] = data.inter_ub[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
          interData.c[i] = data.inter_uc[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
        }
        // this.showRms = {
        //   a: Number(data ? data.ua_rms : 0).toFixed(1) + 'V',
        //   b: Number(data ? data.ub_rms : 0).toFixed(1) + 'V',
        //   c: Number(data ? data.uc_rms : 0).toFixed(1) + 'V'
        // }
        this.rangeoption1.series[0].data = interData.a
        this.rangeoption1.series[1].data = interData.b
        this.rangeoption1.series[2].data = interData.c
        this.Chart.setOption(this.rangeoption1)

        console.log(data)
      } else if (this.posSelectValue === 2) {
        for (i = 0; i < 80; i++) {
          this.rangeoption2.xAxis[0].data[i] = (this.freqSelectValue - 1) * 400 + i * 5 + 5

          interData.a[i] = data.inter_ia[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
          interData.b[i] = data.inter_ib[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
          interData.c[i] = data.inter_ic[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
          interData.n[i] = data.inter_in[(this.freqSelectValue - 1) * 80 + i].toFixed(1)
        }
        // this.showRms = {
        //   a: Number(data ? data.ia_rms : 0).toFixed(1) + 'A',
        //   b: Number(data ? data.ib_rms : 0).toFixed(1) + 'A',
        //   c: Number(data ? data.ic_rms : 0).toFixed(1) + 'A',
        //   n: Number(data ? data.in_rms : 0).toFixed(1) + 'A'
        // }
        this.rangeoption2.series[0].data = interData.a
        this.rangeoption2.series[1].data = interData.b
        this.rangeoption2.series[2].data = interData.c
        this.rangeoption2.series[3].data = interData.n
        this.Chart.setOption(this.rangeoption2)
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <div style="width: 50vw; height: 70px;  display: flex; align-items: center">
      <div style="width: 80px;">频段</div>

      <div style="width: 150px; font-size: 20px;">
        <el-select v-model="freqSelectValue" placeholder="请选择" size="20px">
          <el-option
            v-for="item in freqSelectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>

<!--      <div-->
<!--        style="display: flex; align-items: center; margin-left: 20px;">-->
<!--        <div style="width: 80px">有效值</div>-->
<!--        <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">-->
<!--          <div style="display: flex">-->
<!--            <div style="width: 40%; margin-right: 5px">A相</div>-->
<!--            <div style="width: 60%; text-align: center">{{ showRms.a }}</div>-->
<!--          </div>-->
<!--        </el-button>-->
<!--        <el-button style="width: 130px; font-size: 20px;">-->
<!--          <div style="display: flex">-->
<!--            <div style="width: 40%; margin-right: 5px">B相</div>-->
<!--            <div style="width: 60%; text-align: center">{{ showRms.b }}</div>-->
<!--          </div>-->
<!--        </el-button>-->
<!--        <el-button style="width: 130px; font-size: 20px;">-->
<!--          <div style="display: flex">-->
<!--            <div style="width: 40%; margin-right: 5px">C相</div>-->
<!--            <div style="width: 60%; text-align: center">{{ showRms.c }}</div>-->
<!--          </div>-->
<!--        </el-button>-->
<!--        <el-button style="width: 130px; font-size: 20px;" v-if="posSelectValue===2">-->
<!--          <div style="display: flex">-->
<!--            <div style="width: 40%; margin-right: 5px">N相</div>-->
<!--            <div style="width: 60%; text-align: center">{{ showRms.n }}</div>-->
<!--          </div>-->
<!--        </el-button>-->
<!--      </div>-->
    </div>
    <div class="dataItems">
      <div class="title">间谐波频谱图</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px;">
        <div style="display: flex; width: 100%; flex-direction: column">
          <div
            style="display: flex; align-items: center; margin-left: 20px;">
            <div style="width: 80px;">电气量</div>

            <div style="width: 150px; font-size: 20px; margin-left: 10px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>

<!--            <div style="width: 80px; margin-left: 20px">频段</div>-->

<!--            <div style="width: 150px; font-size: 20px; margin-left: 10px">-->
<!--              <el-select v-model="freqSelectValue" placeholder="请选择" size="20px">-->
<!--                <el-option-->
<!--                  v-for="item in freqSelectOptions"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
          </div>

<!--          <div-->
<!--            style="display: flex; align-items: center; margin-left: 20px; margin-top: 10px">-->
<!--            <div style="width: 80px">有效值</div>-->
<!--            <el-button style="width: 130px; margin-left: 10px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">A相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.a }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">B相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.b }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">C相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.c }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--            <el-button style="width: 130px; font-size: 20px;" v-if="posSelectValue===2">-->
<!--              <div style="display: flex">-->
<!--                <div style="width: 40%; margin-right: 5px">N相</div>-->
<!--                <div style="width: 60%; text-align: center">{{ showRms.n }}</div>-->
<!--              </div>-->
<!--            </el-button>-->
<!--          </div>-->
        </div>
      </div>
      <div style="height: calc(100% - 155px);">
        <div id="rangeOptions" style="height: 100%; width: 100%; border-top: 1px solid black"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";
.pg{
  width: 45%;
  height: calc(65vh - 50px);
}

.dataName {
  width: 10%;
}

.dataValue {
  width: 10%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 70px) / 10);
}

.el-input--suffix .el-input__inner {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Stable/ThdChart/ThdChartRange.vue